'use client'

import { useCheckout, useModals } from '@/lib/hooks'

import { PaymentCard } from '@/components/molecules'
import { ScrollArea } from '@/components/ui'

interface SelectOtherPaymentTypeProps
  extends React.ComponentPropsWithoutRef<'form'> {
  onClose?: () => void
}

export const SelectOtherPaymentType = ({
  onClose,
}: SelectOtherPaymentTypeProps) => {
  const { setPaymentMethod, setCurrentStep, payment_methods } = useCheckout()
  const { openModal } = useModals()
  const handleSubmit = (_data: FormData) => {}

  const handleOnSelect = (method: any) => {
    setPaymentMethod(method)

    if (method?.future_payment_enabled) {
      openModal('FUTURE_PAYMENT_DATE_AND_REFERENCE')
      return
    }

    if (method?.reference_required && method?.is_gift_card === 0) {
      openModal('CUSTOM_REFERENCE')
      return
    }

    if (method?.is_gift_card === 1) {
      openModal('GIFT_CARD_REFERENCE')
      return
    }

    setCurrentStep('COLLECT_PAYMENT')
    onClose?.()
  }

  return (
    <form
      className="flex min-h-[280px] flex-col gap-4 lg:w-full lg:flex-wrap"
      action={handleSubmit}
    >
      <ScrollArea className="max-h-[264px] lg:w-full">
        <div className="flex w-full flex-col gap-2">
          {payment_methods?.other?.map((method: any, index: number) => (
            <PaymentCard
              key={method.id}
              card={method}
              shortcut={index + 1}
              onClick={() => handleOnSelect(method)}
            />
          ))}
        </div>
      </ScrollArea>
    </form>
  )
}
